import { render, staticRenderFns } from "./detailSupply.vue?vue&type=template&id=fb05d8ac&scoped=true"
import script from "./detailSupply.vue?vue&type=script&lang=js"
export * from "./detailSupply.vue?vue&type=script&lang=js"
import style0 from "./detailSupply.vue?vue&type=style&index=0&id=fb05d8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb05d8ac",
  null
  
)

export default component.exports